import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import { Loader } from "components";
import { store, persistor } from "store";
import AppRoutes from "routes/AppRoutes";
import "index.css";
import { ConfigProvider } from "antd";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={<Loader />} persistor={persistor}>
        <ConfigProvider
          theme={{
            token: {
              fontFamily: "Avenir LT Pro 65 Medium",
              fontSize: 20,
            },
          }}
        >
          <AppRoutes />
        </ConfigProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
